import Api from './api';

const ProjetoCulturalService = {

    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/projetocultural/listar',
            params: params
        })
        return response
    },
    buscar: (params) => {
        const response = Api.get(`/projetocultural/buscar?${params}`)
        return response
    }
}

export default ProjetoCulturalService;